module.exports = __webpack_public_path__ + "media/images/stat-total-reviews-5d1ad1d4.svg";